import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';
import SEOContent from './components/SEOContent';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.online';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      name: 'CSSSpreadsheet.online',
      url: siteUrl,
      description: 'Discover verified CSSBuy spreadsheets for sneakers, fashion, luxury items, and budget shopping. Compare top spreadsheet lists updated daily.',
      inLanguage: 'en',
      publisher: {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'CSSSpreadsheet.online',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
        },
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'CSSBuy Spreadsheet – The Most Updated Shopping Spreadsheet List (2026 Guide)',
      description: 'Discover verified CSSBuy spreadsheets for sneakers, fashion, luxury items, and budget shopping. Compare top spreadsheet lists updated daily with beginner-friendly guides and 100% free access.',
      inLanguage: 'en',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20fashion%20product%20collage%20with%20sneakers%20hoodies%20accessories%20on%20warm%20cream%20background%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20gentle%20natural%20lighting%2C%20neutral%20beige%20and%20cream%20tones%2C%20soft%20shadows%2C%20artistic%20composition%2C%20elegant%20lifestyle%20flat%20lay%20with%20various%20fashion%20items%20arranged%20harmoniously&width=1800&height=900&seq=hero-bg-main&orientation=landscape',
        width: '1800',
        height: '900',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <SEOContent />
        <CategoryGrid />
        <ArticlePreview />
        <CTASection />
        <TrustSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}